// extracted by mini-css-extract-plugin
module.exports =  {"grid":"grid_Gy6CNnkf","editing":"editing_SF99XQpv","orgsPanel":"orgsPanel_furRDoy1"};